<template>
  <main>
      <div class="about-wrp content-box fadeInUp">

          <contact-thanks v-if="name"  :name="name"/>

          <contact-form v-else ref="contactForm" @formSubmitted="e=>  name = e.split(' ')[0]"/>
          
      </div>
  </main>
</template>

<script>
import ContactForm from '../components/contact/ContactForm'
import ContactThanks from '../components/contact/ContactThanks'
export default {

    data(){
        return{
            name:null
        }
    },

    components:{
        ContactForm,
        ContactThanks
    }
}
</script>

<style>
.contact-form{
    max-width: 785px;
    width: 100%;
}

.form-group{
    margin-bottom: 2%;
}

.form-group label,
.form-group input,
.form-group textarea{
    display: block;
    width: 100%;
    font-size: 24px !important;
    font-weight: 400 !important;
    color: #707070 !important;
    font-family: 'Poppins', sans-serif;
}

.form-group label{
    margin-bottom: .5%;
}

.form-group input,
.form-group textarea{
    border: solid #707070 1px;
    border-radius: 5px;
    padding: 2.5% 2%;
}

.form-group textarea{
    height: 167px;
    resize: none;
}

.form-group small{
    font-size: 21px;
    color: #707070;
    font-weight: 300;
    margin-bottom: .5%;
    display: block;
}

.contact-form-btn{
    font-size: 24px;
    font-weight: 600;
    color: white;
    background: #161717;
    border: #707070 solid 1px;
    border-radius: 5px;
    cursor: pointer;
    padding: 3% 5.5%;
    margin-top: 2%;
}

.contact-form-btn:hover{
    opacity: .8;
}

.form-footer{
    color: #818181;
    font-size: 17px;
    line-height: 23px;
    font-weight: 300;
    margin-top: 10%;
}

.border-error{
    border-color: red !important;
}

@media screen and (max-width: 589px){
    .form-group label,
    .form-group input,
    .form-group textarea{    
        font-size: 20px !important;
    }

    .form-group small{
        font-size: 18px;
    }

    .contact-form-btn{
        font-size: 20px;
    }
}
</style>